import { render, staticRenderFns } from "./viewCoupon.vue?vue&type=template&id=cdff02c2&"
import script from "./viewCoupon.vue?vue&type=script&lang=js&"
export * from "./viewCoupon.vue?vue&type=script&lang=js&"
import style0 from "./viewCoupon.vue?vue&type=style&index=0&id=cdff02c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports